export default __webpack_public_path__ + "static/bg-email-automation-add9f77ef95ce705666032be13f9a6bb.webp";